var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonUpgrade = function SvgButtonUpgrade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66335 5.4353H3.25158C2.94602 5.4353 2.78483 5.07339 2.98924 4.84626L6.16572 1.31685C6.30592 1.16107 6.55019 1.16107 6.69039 1.31685L9.86686 4.84626C10.0713 5.07339 9.91009 5.4353 9.60453 5.4353H8.19276V8.25883C8.19276 8.45376 8.03474 8.61178 7.83982 8.61178H5.01629C4.82137 8.61178 4.66335 8.45376 4.66335 8.25883V5.4353ZM5.01629 10.9059C4.82137 10.9059 4.66335 10.7479 4.66335 10.553C4.66335 10.358 4.82137 10.2 5.01629 10.2H7.83982C8.03474 10.2 8.19276 10.358 8.19276 10.553C8.19276 10.7479 8.03474 10.9059 7.83982 10.9059H5.01629Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonUpgrade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buttonUpgrade.35175a4e.svg";
export { ForwardRef as ReactComponent };